// extracted by mini-css-extract-plugin
module.exports = {"title":"PriceListItemTitle_title_Urwf9","grey":"PriceListItemTitle_grey_1tAS0"};